import Vue from 'vue';
import axios from 'axios';

Vue.prototype.axios = axios.create({
  baseURL: process.env.VUE_APP_BASE_URI_API_AUTH
})

const token = localStorage.getItem('token')
if (token) {
  Vue.prototype.axios.defaults.headers.common['Authorization'] = "Bearer " + token
}